import React , {useState} from 'react';

import { Accordion } from 'react-bootstrap-accordion';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import data from '../assets/dt-data/data-hotpick'
import icon1 from '../assets/images/icon/rain1.svg'
import icon2 from '../assets/images/icon/rain2.svg'
import icon3 from '../assets/images/icon/ethe.svg'


function Faqs(props) {
    const { addToCart } = useCart();

    const handleAddToCart = (item) => {
        const cartItem = {
            id: item.id,
            name: item.title,
            price: item.price,
            image: item.img,
            quantity: 1
        };
        addToCart(cartItem);
    };

    const [dataFaq] = useState([
        {
            id: 1,
            title: 'What is D.T Wallet?',
            text : 'D.T Wallet is India\'s leading digital voucher marketplace where you can buy, store, and redeem vouchers from top brands. We provide a secure digital vault to keep all your gift cards and vouchers in one place, accessible anytime, anywhere.'
        },
        {
            id: 2,
            title: 'How do I purchase vouchers on D.T Wallet?',
            text : 'Purchasing vouchers is simple! Browse our collection of vouchers from top brands, select the voucher you want, add it to your cart, and proceed to checkout. We accept all major payment methods including credit/debit cards, UPI, and net banking. Once payment is confirmed, your voucher will be instantly delivered to your vault.'
        },
        {
            id: 3,
            title: 'How do I redeem my vouchers?',
            text : 'To redeem your vouchers, go to My Vault in your dashboard where all your purchased vouchers are stored. Select the voucher you want to use, and follow the redemption instructions provided. Each voucher comes with a unique code that you can use at the partner store or online platform.'
        },
        {
            id: 4,
            title: 'Are my vouchers and payment details secure?',
            text : 'Absolutely! We use industry-standard encryption and secure payment gateways to protect your transactions. Your vouchers are safely stored in your digital vault with secure access. We never share your personal or payment information with third parties. All transactions are processed through verified and trusted payment partners.'
        },
        {
            id: 5,
            title: 'What is your refund policy?',
            text : 'Refunds are applicable only if payment is deducted but the voucher is not delivered to your vault, or in case of duplicate transactions. Please contact our support team within 7 days with your transaction proof for resolution. Once a voucher is delivered and the code is revealed, it cannot be refunded as per our policy.'
        },
        {
            id: 6,
            title: 'How quickly can I get customer support?',
            text : 'Our dedicated customer support team is available 24/7 to assist you. You can reach us through the Contact page, email us, or use the live chat feature. We typically respond to queries within a few hours and strive to resolve all issues as quickly as possible.'
        },
    ])
    return (
        <div>

        <section className="tf-page-title style-2">    
                <div className="tf-container">
                    <div className="row">
                        <div className="col-md-12">

                            <ul className="breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="#">Pages</Link></li>
                                <li>FAQs</li>
                            </ul>
                   
                        </div>
                    </div>
                </div>                    
            </section>
                
            <section className="tf-faq">
                <div className="tf-container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="tf-heading style-5">
                                <h4 className="heading">Frequently Asked Questions</h4>
                                <p className="sub-heading">Find answers to common questions about D.T Wallet, buying vouchers, managing your vault, and redeeming your digital gift cards.</p>
                            </div>
                            <div className="tf-accordion">
                                {
                                    dataFaq.map(idx => (
                                        <Accordion key={idx.id} title={idx.title} className='tf-toggle-title h6'>
                                            <p className="toggle-content">{idx.text} </p>
                                        </Accordion>
                                    ))
                                }
                             
                                                    
                            </div> 
                        </div>
                    </div>
                </div>
            </section >
                
            <section className='tf-explore-more'>
                <div className="tf-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="tf-heading center">
                                <h4 className="heading">Explore Hot Vouchers</h4>
                            </div>
                        </div>

                        {
                                    data.slice(0,4).map((idx, index) =>{
                                        const discounts = ['10%', '15%', '8%', '12%'];
                                        const discount = discounts[index % discounts.length];
                                        
                                        return (
                                        <div key={idx.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                            <div className="sc-product style2" style={{position: 'relative'}}>
                                                <div className="top">
                                                    <Link to="/dt-shop" className="tag">{idx.title}</Link>
                                                    <div 
                                                        style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            right: '10px',
                                                            background: '#FFC107',
                                                            color: '#000',
                                                            padding: '6px 12px',
                                                            borderRadius: '20px',
                                                            fontSize: '13px',
                                                            fontWeight: '700',
                                                            zIndex: 2
                                                        }}
                                                    >
                                                        {discount} OFF
                                                    </div>
                                                </div>
                                                
                                                <div className="features">
                                                    <div className="product-media">
                                                        <img src={idx.img} alt="images" />
                                                    </div>
                                                </div>
                                                
                                                <div className="bottom-style2">
                                                    <div className="price">
                                                        <div className="content" style={{width: '100%'}}>
                                                            <div className="cash" style={{fontSize: '18px', fontWeight: '600'}}>{idx.price}</div>
                                                        </div>
                                                    </div>
                                                    <div className="product-button">
                                                        <button 
                                                            onClick={() => handleAddToCart(idx)} 
                                                            className="tf-button"
                                                            style={{
                                                                background: '#FFC107',
                                                                color: '#000',
                                                                border: 'none',
                                                                fontWeight: '600',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            Add to Cart
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        );
                                    })
                                }

                    </div>
                </div>

            </section>
            
        </div>
    );
}

export default Faqs;